import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"
import {TextureType} from "@generated"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            angleInDegrees: z.number().min(-180).max(180).optional().default(0),
            textureType: z.nativeEnum(TextureType),
        }),
    },
}
